/**
 * File custom.js.
 */

(function ($) {
	'use strict';

	$(document).ready(function () {

		$('.search-form').submit(function (e) {
            // Get the value from the search input field

            let searchValue = $(this).parent().find('.search-field').val();
            // Check if the search value has at least 3 characters
            if (searchValue.length < 3) {
                // Prevent the form from submitting
                e.preventDefault();

                // Insert the error message dynamically
                $(this).parents( '.search-form-wrapper' ).find('.error-message').show();
            } else {
                // Clear any previous error messages
                $(this).parents( '.search-form-wrapper' ).find('.error-message').hide();
            }
		});

		// Popup clicking by ID
		$(document).on("click", ".marketing-site-main a, .site-main a", function () {
			let getURL     = $(this).attr('href');
			let getPopupId = getURL.replace('##', '.');

			if ( getPopupId !== '' && getPopupId !== '.' && getURL.indexOf('##') !== -1 ) { 
				$(getPopupId).click();
				return false;
			}
		});

		//add target blank wherever in site found a tag with pdf
		// Get all anchor tags
		var anchorTags = document.querySelectorAll('a');
	
		// Iterate through each anchor tag
		anchorTags.forEach(function (anchor) {
			// Check if href ends with '.pdf' and target="_blank" doesn't exist
			if (
			anchor.getAttribute('href') &&
			anchor.getAttribute('href').toLowerCase().endsWith('.pdf') &&
			!anchor.getAttribute('target')
			) {
			// Add target="_blank" attribute
			anchor.setAttribute('target', '_blank');
			}
		});
	});

})(jQuery);
